// extracted by mini-css-extract-plugin
export default {"navDescription":"JHaMef85"};